module.exports = __webpack_public_path__ + "static/media/badge_money_3.aa562c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_money_3.png
// module id = 519
// module chunks = 0